// extracted by mini-css-extract-plugin
export default {"title":"WhyUsSection_title__Iw9Th","description":"WhyUsSection_description__aoVfj","card":"WhyUsSection_card__cisNv","cardTitle":"WhyUsSection_cardTitle__QbLfn"};